import React from 'react';

const DropdownQuestionBlock = ({ question, register, errors }) => {
    return (
        <div className="mb-4">
            <label className="form-label mb-0">
                {question.title} {question.required && "*"}
            </label>
            {question.description && (
                <p className="text-muted"><small>{question.description}</small></p>
            )}
            <select
                className="form-select"
                {...register(question.internalId, {
                    required: question.required ? `${question.title} is required` : false,
                })}
            >
                <option value="">{question.placeholder || "Select an option"}</option>
                {question.options?.map((opt) => (
                    <option key={opt.id} value={opt.value}>
                        {opt.text}
                    </option>
                ))}
            </select>
            {errors[question.internalId] && (
                <div className="text-danger small">{errors[question.internalId].message}</div>
            )}
        </div>
    );
};

export default DropdownQuestionBlock;